import { UserManagementProvider } from "../../../../providers/UserManagementProvider";
import UserManagementPage from "../UserManagementPage";

export default function UserManagementRoot() {
  return (
    <UserManagementProvider>
      <UserManagementPage />
    </UserManagementProvider>
  );
}